const STORAGE_KEY = "hireqix_cookie_consent";
export const CONSENT_VERSION = 1;
export const CONSENT_EVENT = "hireqix:consent-changed";
export const OPEN_PREFERENCES_EVENT = "hireqix:open-cookie-preferences";

export function getConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent({ analytics = false, marketing = false }) {
  const consent = {
    version: CONSENT_VERSION,
    essential: true,
    analytics,
    marketing,
    updated_at: new Date().toISOString(),
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  applyConsent(consent);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: consent }));
  return consent;
}

function gtag(...args) {
  // index.html defines the canonical gtag(); fall back to a dataLayer push if absent.
  if (typeof window.gtag === "function") {
    window.gtag(...args);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(args);
}

// Google Consent Mode v2 — everything non-essential starts denied and is only
// granted once the visitor opts in. Analytics/ads scripts are not loaded before that.
export function initConsentMode() {
  const existing = getConsent();
  if (existing) applyConsent(existing);
}

export function applyConsent(consent) {
  gtag("consent", "update", {
    analytics_storage: consent.analytics ? "granted" : "denied",
    ad_storage: consent.marketing ? "granted" : "denied",
    ad_user_data: consent.marketing ? "granted" : "denied",
    ad_personalization: consent.marketing ? "granted" : "denied",
  });
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(OPEN_PREFERENCES_EVENT));
}

export const COOKIE_TABLE = [
  { name: "access_token", category: "Essential", purpose: "Keeps you signed in to your workspace", retention: "15 minutes" },
  { name: "refresh_token", category: "Essential", purpose: "Renews your session without asking you to sign in again", retention: "7 days" },
  { name: "csrf_token", category: "Essential", purpose: "Protects your account against cross-site request forgery", retention: "7 days" },
  { name: "hireqix_cookie_consent", category: "Essential", purpose: "Remembers your cookie choices (stored locally)", retention: "12 months" },
  { name: "activeWorkspaceId / theme", category: "Essential", purpose: "Remembers your selected workspace and light/dark preference (stored locally)", retention: "Until cleared" },
  { name: "_ga / _ga_*", category: "Analytics", purpose: "Google Analytics (G-ML6C7264VY) — anonymous usage statistics with IP anonymisation. Only set if you allow analytics", retention: "Up to 24 months" },
];
